import HttpStudent from "@/utils/httpStudent.js";
import HttpTeacher from "@/utils/httpTeacher.js";
import HttpCompany from "@/utils/httpCompany.js";
import Http from "@/utils/http.js";

// 角色和任务角色类型映射
const userTypeMap = {
    1: 0, // 管理员，0 - 查询全部
    2: 0,
    3: 1, // 教师，user_type = 1
    4: -1, // 学生，不走该逻辑
    5: 2, // 企业，user_type = 2
};

// 根据角色不同返回指定的路由, index-列表页，edit-编辑页，detail-详情页
const getRoleRouter = (type) => {
    const role = Number(localStorage.getItem("role"));
    // 角色路由映射
    const roleRouterMap = {
        1: {
            index: "/admin/newTask/index",
            edit: "",
            detail: "/admin/newTask/detail",
        },
        2: {},
        3: {
            index: "/teacher/newTask/index",
            edit: "/teacher/newTask/publish",
            detail: "/teacher/newTask/detail",
        },
        4: {},
        5: {
            index: "/company/newTask/index",
            edit: "/company/newTask/publish",
            detail: "/company/newTask/detail",
        },
    };

    return roleRouterMap[role]?.[type] ?? "";
};

// 请求方法
const request = () => {
    const role = localStorage.getItem("role");

    const httpMap = {
        1: Http,
        2: Http,
        3: HttpTeacher,
        4: HttpStudent,
        5: HttpCompany,
    };

    return httpMap[Number(role)];
};

// 操作弹框数据
const actionDialogMap = {
    fail: {
        title: "淘汰TA",
        formOptions: [{ type: "textarea", label: "淘汰理由", desc: "请输入作品淘汰理由" }],
    },

    backup: {
        title: "备选确认",
        formOptions: [
            {
                type: "textarea",
                label: "修改意见",
                desc: "请输入修改意见，用户根据你提的意见修改稿件，更加高效的达到你的要求",
            },
        ],
    },

    end: {
        title: "终止签约",
        formOptions: [{ type: "textarea", label: "终止说明", desc: "请输入终止签约理由(必填)" }],
    },

    pass: {
        title: "验收通过",
        formOptions: [
            { type: "score", label: "评分" },
            { type: "textarea", label: "理由", desc: "聊聊本次合作感受，你的评价能帮助到其他人~" },
        ],
    },

    return: {
        title: "返工",
        formOptions: [{ type: "textarea", label: "返工理由", desc: "请输入返工理由(必填)" }],
    },

    rating: {
        title: "评价",
        formOptions: [
            { type: "score", label: "评分" },
            { type: "textarea", label: "评价", desc: "聊聊本次合作感受，你的评价能帮助到其他人~" },
        ],
    },
};

// 格式化时间字符串，去除秒
const getTimeLabel = (val) => {
    if (!val) return "";

    const date = new Date(val);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}`;
};

export { request, actionDialogMap, getTimeLabel, userTypeMap, getRoleRouter };
